<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <!-- 头部的标题和logo -->
    <transition name="sidebarLogoFade">
      <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <!-- <img v-if="logo" src="../../../assets/list_logo.png" class="sidebar-logo logo-Small"> -->
        <span v-if="logo" class="sidebar-logo logo-Small"> <svg-icon icon-class="logo-menu" /></span>
        <!-- <h1 v-else class="sidebar-title">{{ title }}</h1> -->
        <!-- list_logo.png -->
      </router-link>
      <router-link v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="logo" src="../../../assets/Logo-menu.png" class="sidebar-logo">
        <!-- <h1 class="sidebar-title">{{ title }} </h1> -->
      </router-link>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      title: 'CXC System',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #2a2d34;
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 35%;
      height: 60px;
      vertical-align: middle;
      margin: 10px auto;
    }
    & .logo-Small{
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      margin: 0 auto !important;
      .svg-icon{
        width: 48px;
        height: 40px;
        color: #fff;
        margin-right: 0 !important;
      }
    }
    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }

}
.sidebar-logo-container:hover{
  background:#01b075 ;
  color: #FFF;
}

</style>
